import { Component, OnInit } from '@angular/core';
import { SharedService } from '../shared.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {

  showLoader: boolean;

  constructor(private sharedService: SharedService) { }

  ngOnInit() {
    this.sharedService.getLoaderStatus().subscribe(resp => {
      this.showLoader = resp;
    });
  }



}
